import { render, staticRenderFns } from "./FollowupHeader.vue?vue&type=template&id=fc9a58e4&scoped=true"
import script from "./FollowupHeader.vue?vue&type=script&lang=js"
export * from "./FollowupHeader.vue?vue&type=script&lang=js"
import style0 from "./FollowupHeader.vue?vue&type=style&index=0&id=fc9a58e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9a58e4",
  null
  
)

export default component.exports